export default {
  getObjectStore(dbName = '_yy', storeName = 'repeat_task', mode = 'readwrite', version = 1) {
    let request = window.indexedDB.open(dbName, version);
    request.onupgradeneeded = (e) => {
      let db = e.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { autoIncrement: true });
      }
    };
    return new Promise((resolve) => {
      request.onsuccess = (e) => {
        let db = e.target.result;
        let objectStore = db.transaction([storeName], mode).objectStore(storeName);
        resolve(objectStore);
      };
    });
  },

  requestSuccess(request) {
    return new Promise((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve(e);
      };
      request.onerror = (e) => {
        reject(e);
      };
    });
  },
};
